<ng-template #content>
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" *ngIf="formCreated">
    <table class="table w-100">
      <tbody>
        <tr>
          <th>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="subscriptionTypeBasic" formControlName="subscriptionTypeId" [value]="1" (change)="changeSubscriptionType(1)">
              <label class="form-check-label" for="subscriptionTypeBasic" i18n="@@subscriptionTypeBasicLabel">
                Basic
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="subscriptionTypeStandard" formControlName="subscriptionTypeId" [value]="2" (change)="changeSubscriptionType(2)">
              <label class="form-check-label" for="subscriptionTypeStandard" i18n="@@subscriptionTypeStandardLabel">
                Standard
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="subscriptionTypePremium" formControlName="subscriptionTypeId" [value]="3" (change)="changeSubscriptionType(3)">
              <label class="form-check-label" for="subscriptionTypePremium" i18n="@@subscriptionTypePremiumLabel">
                Premium
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="subscriptionTypeEnterprise" formControlName="subscriptionTypeId" [value]="4" (change)="changeSubscriptionType(4)">
              <label class="form-check-label" for="subscriptionTypeEnterprise" i18n="@@subscriptionTypeEnterpriseLabel">
                Enterprise
              </label>
            </div>
          </th>
          <th i18n="@@FadeinGreyOut">Einblenden/Ausgrauen</th>
        </tr>

        <tr>
          <td i18n="@@FeaturesNavigation">Features Navigation</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@NaviDashBoard">Navi - Dashboard</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="navDashboard" formControlName="navDashboard">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@NaviChargingStation">Navi - Ladestationen</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="navChargingstations" formControlName="navChargingstations">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@NaviEvaluation">Navi - Auswertung</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="navEvaluation" formControlName="navEvaluation">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@NaviManagement">Navi - Verwaltung</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="navManage" formControlName="navManage">
            </div>
          </td>
        </tr>

        <tr>
          <td i18n="@@FeatureDashBoard">Features Dashboard</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@WidgetChargingstations">Widget Ladestationen</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dashboardChargingstations" formControlName="dashboardChargingstations">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@WidgetConsumptionPowerChart">Widget Verbrauch</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchart" formControlName="dashboardPowerchart">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@WidgetNewTransaction">Widget Neuste Ladevorgänge</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dashboardLatestTransactions" formControlName="dashboardLatestTransactions">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@WidgetProfile">Widget Profil</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dashboardProfile" formControlName="dashboardProfile">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@PowerChartDailyView">Verbrauch Dropdown - Tag Ansicht</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartDay" formControlName="dashboardPowerchartDay">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@PowerChartMonthlyView">Verbrauch Dropdown - Monat Ansicht</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartMonth" formControlName="dashboardPowerchartMonth">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@PowerCharYearlyView">Verbrauch Dropdown - Jahr Ansicht</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartYear" formControlName="dashboardPowerchartYear">
            </div>
          </td>
        </tr>

        <tr>
          <td i18n="@@FeatureChargingstations">Features Ladestationen</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@TabChargingGroups">Reiter Ladestationsgruppen</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingstationsGroups" formControlName="chargingstationsGroups">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@AddChargingStations">Ladestationen hinzufügen</strong>
          </th>
          <td>
            <div class="form-group row">
              <div class="col-lg-3">
                <input class="form-control" type="number" id="chargingstationsCreate" formControlName="chargingstationsCreate">
              </div>
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@DetailsOverviewTabAuthorization">Detailansicht - Reiter Autorisierung</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingstationDetailsAuth" formControlName="chargingstationDetailsAuth">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@DetailsOverviewTabTransactions">Detailansicht - Reiter Ladeprotokoll</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingstationDetailsTransactions" formControlName="chargingstationDetailsTransactions">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@FreeChargeMode">FreeCharge Mode</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingstationFreecharge" formControlName="chargingstationFreecharge">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@TransactionRemoteStart">Ladevorgang freigeben</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingstationRemoteStart" formControlName="chargingstationRemoteStart">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@AddChargingGroups">Gruppen hinzufügen</strong>
          </th>
          <td>
            <div class="form-group row">
              <div class="col-lg-3">
                <input class="form-control" type="number" id="chargingstationGroupsCreate" formControlName="chargingstationGroupsCreate">
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td i18n="@@FeaturesEvaluation">Features Auswertung</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@TabTransactions">Reiter Ladevorgänge</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="evaluationTransactions" formControlName="evaluationTransactions">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@TabDeliverynotes">Reiter Lieferscheine</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="evaluationDeliveryNotes" formControlName="evaluationDeliveryNotes">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsWeeklyView">Ladestatistik - Wochen Ansicht</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsWeek" formControlName="chargingStatisticsWeek">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsMonthlyView">Ladestatistik - Monat Ansicht</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsMonth" formControlName="chargingStatisticsMonth">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsYearlyView">Ladestatistik - Jahr Ansicht</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsYear" formControlName="chargingStatisticsYear">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsCustomizedView">Ladestatistik - Zeitraum wählbar</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsCustom" formControlName="chargingStatisticsCustom">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsFilter">Ladestatistik - Filter (Dropdownfelder)</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsFilter" formControlName="chargingStatisticsFilter">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsCheckbox">Ladestatistik - Checkboxen</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsCheckbox" formControlName="chargingStatisticsCheckbox">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsDateFilter">Ladestatistik - Datumsfilter (Auswahl des Zeitraumes)</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsDateFilter" formControlName="chargingStatisticsDateFilter">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@DeliveryNotesSendOptions">Lieferscheine - Versandt Option</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="evaluationDeliveryNotesSend" formControlName="evaluationDeliveryNotesSend">
            </div>
          </td>
        </tr>

        <tr>
          <td i18n="@@FeaturesManagement">Features Verwaltung</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@AddUsers">Benutzer - Benutzer hinzufügen</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="manageUsersCreate" formControlName="manageUsersCreate">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@UsersCount">Benutzer - Anzahl Benutzer</strong>
          </th>
          <td>
            <div class="form-group row">
              <div class="col-lg-3">
                <input class="form-control" type="number" id="manageUsersCreateCount" formControlName="manageUsersCreateCount">
              </div>
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@RfidCardScan">RFID-Karten anlernen</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="manageRfidScan" formControlName="manageRfidScan">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@CreateIndividualDeliveryNote">Individuelle Lieferscheine erstellen</strong>
          </th>
          <td>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="createDeliveryNotes" formControlName="createDeliveryNotes">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="float-end">
      <button type="submit" id="save_changes" class="btn btn-yellow" [disabled]="subscriptionTypeId != 4" i18n="@@SaveChangesButton">Änderung speichern</button>
    </div>
  </form>
</ng-template>

<div>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
